
require('./bootstrap');
require('bootstrap');
require('./layout');